import SelectAllButton from './SelectAllButton';

export default SelectAllButton;



// WEBPACK FOOTER //
// ./src/components/atoms/SelectAllButton/index.js